<template>
  <div>
    <div v-if="!isReady" class="loader loader--page">
      <div class="loader__animation"></div>
    </div>
  </div>
</template>

<script>
import constants from '../../lib/constants'

const { pageReady } = constants.regex

export default {
  data() {
    return {
      isReady: pageReady,
    }
  },
  created() {
    jQuery('#master-loader').addClass('master-loader--initialized')
  },
  mounted() {
    if (!this.isReady) {
      jQuery(document).on('document-ready', () => {
        this.isReady = true
        jQuery('#master-loader').removeClass('master-loader--initialized')
        jQuery('#master-loader').addClass('master-loader--completed')
      })
    }
  },
}
</script>
